import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { logEvent } from '../../services/analytics';
import Logo from '../brand/Logo';

/**
 * Public landing header: brand logo + auth actions.
 * Logged-out: Login + Start free. Logged-in: Go to Dashboard.
 */
export default function LandingHeader() {
  const { t } = useTranslation();
  const { currentUser } = useAuth();

  return (
    <header className="w-full">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Logo to="/" size={32} />

        <nav className="flex items-center gap-3">
          {currentUser ? (
            <Link
              to="/home"
              onClick={() => logEvent('Landing', 'header_click', 'dashboard')}
              className="btn-gradient inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white"
            >
              {t('home.hero.goToDashboard')}
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                onClick={() => logEvent('Landing', 'header_click', 'login')}
                className="inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-semibold text-text-primary hover:bg-bg-tertiary"
              >
                {t('home.hero.login')}
              </Link>
              <Link
                to="/register"
                onClick={() => logEvent('Landing', 'header_click', 'register')}
                className="btn-gradient inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white"
              >
                {t('home.hero.ctaPrimary')}
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
